<template>
	<div class="row-intervention-edit" :class="(errors && errors.length > 0) ? 'mb-6': 'mb-2'">
		<div class="md-layout mt-1.5">
			<div class="md-layout-item md-size-15">
				<div class="md-vdatepicker">
					<datetime
						v-model="duration"
						type="time"
						auto
						input-id="duration"
						placeholder="HH:mm"
						:phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
						:minute-step="5"
						:disabled="deactivating"
						@close="updatePrevisionRow">
						<label slot="before">Durée *</label>
					</datetime>
					<validation-error :errors="apiValidationErrors.duration" />
				</div>
			</div>
			<div class="md-layout-item md-size-35">
				<md-field class="md-invalid">
					<label>Commentaire</label>
					<md-textarea
						v-model="comment"
						name="comment"
						md-autogrow
						:disabled="deactivating"
						@blur="updatePrevisionRow">
					</md-textarea>
					<validation-error :errors="apiValidationErrors.comment" />
				</md-field>
			</div>
			<div class="md-layout-item md-size-40">
				<div class="md-multiselect md-multiselect-multiple">
					<label>Groupements</label>
					<multiselect
						v-model="selectedDeviceGroups"
						:options="deviceGroups"
						:multiple="true"
						:close-on-select="false"
						:clear-on-select="false"
						:preserve-search="true"
						:show-labels="false"
						:disabled="deactivating"
						label="name"
						placeholder="Groupements"
						track-by="id"
						@close="updatePrevisionRow">
						<template slot="noOptions">La liste est vide</template>
						<template slot="noResult">Aucun élement correspondant</template>
					</multiselect>
					<validation-error :errors="apiValidationErrors.device_groups" />
				</div>
			</div>
			<div class="md-layout-item md-size-5">
				<div class="text-center h-full flex items-center">
					<div>
						<md-button class="md-icon-button md-raised md-danger" :disabled="deactivating" @click="deactivateIntervention">
                            <font-awesome-icon class="md-icon" :icon="['fa', deactivating ? 'sync-alt' : 'ban']" :class="{ 'animate-spin': deactivating }" />
						</md-button>
						<md-tooltip md-direction="top">Désactiver l'intervention</md-tooltip>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
	name: "InterventionPlanEditInterventionRow",
	components: {
		ValidationError
	},
	mixins: [formMixin],
	props: {
		prevision: {
		    type: Object,
            default() {
		        return {
		            commentable: null,
                    device_groups: []
                }
            }
        },
        deviceGroups: Array,
        errors: Array
	},
	data() {
		return {
            id: null,
            duration: null,
            comment: null,
            selectedDeviceGroups: [],
			deactivating: false
		}
	},
	methods: {
		updatePrevisionRow() {
			this.$emit('update-prevision', {
				id: this.prevision.id,
				duration: this.calculDuration(this.duration),
				comment: this.comment,
				deviceGroups: this.selectedDeviceGroups
			})
		},
        deactivateIntervention() {
            this.$swal.fire({
                title: "Êtes-vous sûr ?",
                html: 'Voulez-vous désactiver cette intervention ?',
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-warning",
                confirmButtonText: "Désactiver",
                cancelButtonText: "Annuler",
                buttonsStyling: false,
            }).then(async result => {
                if(result.value) {
					this.deactivating = true
	                try {
		                await this.$store.dispatch('interventionPlans/deactivateIntervention', { interventionPrevisionId: this.id })
		                await this.$store.dispatch('alerts/success', 'Intervention désactivée')

		                await this.$emit('deactivate-prevision', { id: this.id })
	                } catch(error) {
		                await this.$store.dispatch("alerts/error", "Désactivation impossible")
	                } finally {
		                this.deactivating = false
	                }
                }
            });
        },
		calculDuration(duration) {
			if(Date.parse(duration)) {
				let hours = parseInt(this.$moment(duration).format('HH'))
				let minutes = parseInt(this.$moment(duration).format('mm'))
				return ((hours * 60) + minutes)
			} else {
				let schedules = duration.toString().split(':')
				return ((parseInt(schedules[0]) * 60) + parseInt(schedules[1]))
			}
		},
		formatDuration() {
			const hours = Math.floor(this.prevision.duration / 60)
			const minutes = this.prevision.duration - (hours * 60)
			this.duration = this.$moment(new Date().setHours(hours, minutes)).format('HH:mm')
		}
	},
	watch: {
        'errors'(newVal) {
            this.resetApiValidation()
            if (newVal) {
                this.setApiValidation(newVal)
            }
        }
	},
	mounted() {
        this.id = this.prevision.id
		this.selectedDeviceGroups = this.prevision.device_groups
		this.comment = this.prevision.commentable ? this.prevision.commentable.comment : null
		this.formatDuration()
	}
}
</script>

<style scoped lang="scss">
.md-layout-item.pl-0:first-child {
	padding-left: 0 !important;
}
.row-intervention-edit:last-child {
    &.mb-2 {
        margin-bottom: 0 !important;
    }
}
</style>
